// A product's diet marker as a dot and a label — never colour alone (spec/13 §6.1, and BRAND: the
// green veg / red non-veg marker). Shared by the Sell and F&B menu screens.
import type { FoodDietMarker } from '@clavian/api-client';
import { useTranslation } from '@clavian/i18n/react';
import type { ReactNode } from 'react';

import './diet.css';

export function DietMarker({ marker }: { readonly marker: FoodDietMarker }): ReactNode {
  const { t } = useTranslation('console');
  if (marker === 'none') return null;
  return (
    <span className={`console-diet console-diet--${marker}`}>
      <span className="console-diet__dot" aria-hidden="true" />
      {t(`menu.diet.${marker}`)}
    </span>
  );
}

export function DietLegend(): ReactNode {
  const { t } = useTranslation('console');
  return (
    <p className="console-diet-legend console-muted">
      {(['veg', 'egg', 'non_veg', 'vegan'] as const).map((marker) => (
        <span key={marker} className={`console-diet console-diet--${marker}`}>
          <span className="console-diet__dot" aria-hidden="true" />
          {t(`menu.diet.${marker}`)}
        </span>
      ))}
    </p>
  );
}
